var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialOfferClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.69391 5.73076C5.89039 5.79625 6.10276 5.69006 6.16826 5.49359C6.23375 5.29711 6.12756 5.08474 5.93109 5.01924L5.69391 5.73076ZM4.5 4.9375H4.125C4.125 5.09891 4.22829 5.24221 4.38141 5.29326L4.5 4.9375ZM4.875 3.10812C4.875 2.90101 4.70711 2.73312 4.5 2.73312C4.29289 2.73312 4.125 2.90101 4.125 3.10812H4.875ZM5.8125 5.375L5.93109 5.01924L4.61859 4.58174L4.5 4.9375L4.38141 5.29326L5.69391 5.73076L5.8125 5.375ZM4.5 4.9375H4.875V3.10812H4.5H4.125V4.9375H4.5ZM8 4.5H7.625C7.625 6.22589 6.22589 7.625 4.5 7.625V8V8.375C6.6401 8.375 8.375 6.6401 8.375 4.5H8ZM4.5 8V7.625C2.77411 7.625 1.375 6.22589 1.375 4.5H1H0.625C0.625 6.6401 2.3599 8.375 4.5 8.375V8ZM1 4.5H1.375C1.375 2.77411 2.77411 1.375 4.5 1.375V1V0.625C2.3599 0.625 0.625 2.3599 0.625 4.5H1ZM4.5 1V1.375C6.22589 1.375 7.625 2.77411 7.625 4.5H8H8.375C8.375 2.3599 6.6401 0.625 4.5 0.625V1Z",
    fill: "#00123A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialOfferClock);
export default __webpack_public_path__ + "static/media/SpecialOfferClock.b2379ef1230db29485bf621c244d47b8.svg";
export { ForwardRef as ReactComponent };